import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './custom.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { initializeFirebase, getFirebaseMessaging } from './push-notification';
import { onMessage } from 'firebase/messaging';

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
// We execute the same script as before
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

initializeFirebase();

// Handle foreground messages
const messaging = getFirebaseMessaging();
if (messaging) {
    onMessage(messaging, (payload) => {
        console.log('Message received:', payload);
    });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
